'use strict';

var Sizzle = require('sizzle');
import * as domUtils from '../util/dom';
var Debug = require('../util/debug')('thumbnails');

var NAMESPACE = 'thumbnails';

var CLASSNAMES = {
	progressHandle: 'svp_js-controls-timeline--progress-handle',
	progressMetadata: 'svp_js-controls-timeline--progress-metadata',
	thumbnail: 'svp_js-controls-timeline--progress-thumbnail',
	shadow: 'svp_js-controls-timeline--progress-thumbnail-shadow',
	timelineInner: 'svp_js-controls-timeline--inner',
	timeline: 'svp_js-controls-timeline'
};

module.exports = {
	create: function (api) {
		if (!api.config.controls) {
			return;
		}

		var videoId,
			thumbnailUrl,
			cols,
			width,
			height,
			timegap;

        function dragEventFn(e) {
            var left = 0,
                timeline = _getElement(CLASSNAMES.timeline),
                thumbnail = _getElement(CLASSNAMES.thumbnail),
                shadow = _getElement(CLASSNAMES.shadow),
                rect = timeline.getBoundingClientRect(),
                xPos = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
            if (xPos > rect.left) {
                if (xPos >= (rect.left + timeline.clientWidth)) {
                    left = 100;
                } else {
                    var position = xPos - (rect.left + window.pageXOffset);
                    left = 100 * (position / timeline.clientWidth);
                }
            }
            var time = left / 100 * api.getDuration();

            var baseTime = time + timegap;
			var row = Math.floor(baseTime / (timegap * cols));
			var xpos = (Math.floor(baseTime / timegap) * width) - (row * width * cols);
			var ypos = row * height;

            thumbnail.style.backgroundPosition = '-' + xpos + 'px -' + ypos + 'px';
            thumbnail.style.display = 'block';
            shadow.style.display = 'block';
        }

		function mouseupFn() {
			var thumbnail = _getElement(CLASSNAMES.thumbnail),
				shadow = _getElement(CLASSNAMES.shadow);
			document.removeEventListener('mousemove', dragEventFn);
			document.removeEventListener('touchmove', dragEventFn);
			document.removeEventListener('mouseup', mouseupFn);
			document.removeEventListener('touchend', mouseupFn);

			thumbnail.style.display = 'none';
			shadow.style.display = 'none';
		}
		function dragStartFn() {
			document.addEventListener('mousemove', dragEventFn);
			document.addEventListener('touchmove', dragEventFn);
			document.addEventListener('mouseup', mouseupFn);
			document.addEventListener('touchend', mouseupFn);
		}

		function _getElement(className) {
			return Sizzle('.' + className, api.element())[0];
		}

		function _resetUi() {
			var progressMetadataElement = _getElement(CLASSNAMES.progressMetadata),
				thumbnailElement = _getElement(CLASSNAMES.thumbnail),
				shadowElement = _getElement(CLASSNAMES.shadow);

			if (progressMetadataElement) {
				if (thumbnailElement) {
					progressMetadataElement.removeChild(thumbnailElement);
				}

				if (shadowElement) {
					progressMetadataElement.removeChild(shadowElement);
				}
			}
		}

		function _resetEvents() {
			var progressHandle = _getElement(CLASSNAMES.progressHandle);

			if (progressHandle) {
				domUtils.removeEvents(progressHandle, 'mousedown', NAMESPACE);
				domUtils.removeEvents(progressHandle, 'touchstart', NAMESPACE);
				domUtils.removeEvents(_getElement(CLASSNAMES.timelineInner), 'mouseout, mousemove, touchstart', NAMESPACE);
			}

			document.removeEventListener('mousemove', dragEventFn);
			document.removeEventListener('touchmove', dragEventFn);
			document.removeEventListener('mouseup', mouseupFn);
			document.removeEventListener('touchend', mouseupFn);
		}

		function _buildUi() {
			var progressHandleElement = _getElement(CLASSNAMES.progressMetadata);
			var thumbnailElement = domUtils.fromString(
				'<span aria-hidden="true" class="svp_js-controls-timeline--progress-thumbnail svp_ui-controls-timeline--progress-thumbnail svp_ui-controls--hide-initial"></span>'
			);
			var shadowElement = domUtils.fromString(
				'<span aria-hidden="true" class="svp_js-controls-timeline--progress-thumbnail-shadow svp_ui-controls-timeline--progress-thumbnail-shadow svp_ui-controls--hide-initial"></span>'
			);

			thumbnailElement.style.backgroundImage = 'url(' + thumbnailUrl + ')';

			progressHandleElement.appendChild(thumbnailElement);
			progressHandleElement.appendChild(shadowElement);
		}

		function _bindUiInteractionEvents() {
			var progressHandle = _getElement(CLASSNAMES.progressHandle);

			domUtils.addEvents(progressHandle, 'mousedown', dragStartFn, NAMESPACE);
			domUtils.addEvents(progressHandle, 'touchstart', dragStartFn, NAMESPACE);

			domUtils.addEvents(_getElement(CLASSNAMES.timelineInner), 'mouseout', mouseupFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.timelineInner), 'mousemove', dragEventFn, NAMESPACE);
			domUtils.addEvents(_getElement(CLASSNAMES.timelineInner), 'touchstart', function () {
				domUtils.removeEvents(_getElement(CLASSNAMES.timelineInner), 'mouseout, mousemove, touchstart', NAMESPACE);
			}, NAMESPACE);
		}

		api.on(NAMESPACE + '.metadata', function (metadata) {
			videoId = metadata.detail.programVersionId;
			if (metadata.detail.thumbnailMap) {
				thumbnailUrl = metadata.detail.thumbnailMap.url;
				cols = metadata.detail.thumbnailMap.columns;
				width = metadata.detail.thumbnailMap.thumbnailwidth;
				height = metadata.detail.thumbnailMap.thumbnailheight;
				timegap = metadata.detail.thumbnailMap.timeBetweenPicturesInMillis / 1000;
				_buildUi();
				_bindUiInteractionEvents();
			} else {
				Debug('no thumbnails found for ' + videoId);
			}
		});

		api.filters.push({
			load: function () {
				_resetEvents();
				_resetUi();
			}
		});
	},

	destroy: function (api) {
		var progressHandle = Sizzle('.' + CLASSNAMES.progressMetadata, api.element())[0];

		if (progressHandle) {
			domUtils.removeEvents(progressHandle, 'mousedown', NAMESPACE);
			domUtils.removeEvents(progressHandle, 'touchstart', NAMESPACE);
		}
		api.off(NAMESPACE + '.metadata');
	}

};



// WEBPACK FOOTER //
// ./src/js/plugins/thumbnails.js